import { Component, signal } from '@angular/core';
import { Org } from 'app/classes/org';
import { Site } from 'app/classes/site';
import { APIService } from 'app/shared/api.service';
import { InsightsService } from 'app/shared/insights.service';
import { SiteService } from 'app/shared/site.service';

@Component({
  selector: 'app-insights-ff-lcr',
  standalone: false,
  templateUrl: './insights-ff-lcr.component.html',
  styleUrl: './insights-ff-lcr.component.css',
})
export class InsightsFfLcrComponent {

  report = signal<any>(null);
  site = signal<Site>(null);
  startOfPreviousMonth: Date;
  showDebugging = signal<boolean>(false);
  org: Org = this.apiService.getUserOrg();
  isWaitingForResponse = signal<number>(null);

  constructor(private insightsService: InsightsService, private siteService: SiteService, private apiService: APIService) {

    this.startOfPreviousMonth = new Date();
    this.startOfPreviousMonth.setUTCHours(0, 0, 0, 0);           // reset time to midnight UTC
    this.startOfPreviousMonth.setUTCDate(1);                    // go to 1st of current month
    this.startOfPreviousMonth.setUTCMonth(this.startOfPreviousMonth.getUTCMonth() - 1); // subtract one month

    this.apiService.getSite(440).then(site => this.site.set(site));
    // insightsService.getFootfallLCRInsights(this.startOfPreviousMonth).then(report => this.report.set(report));
    insightsService.startFootfallLCRInsightsJob(this.startOfPreviousMonth).then(startResponse => {
      const uuid = startResponse.uuid;
      console.log('uuid', uuid);
      if (!uuid) return;

      this.isWaitingForResponse.set(0);
      setTimeout(() => {
        this.poll(uuid);
      }, 5000);
    });
  }

  poll(uuid) {
    console.log('polling...');
    this.isWaitingForResponse.update(n => n + 1);
    this.insightsService.pollFootfallLCRInsightsJob(uuid).then(response => {
      if (response?.assets) {
        this.report.set(response);
        console.log('Report received');
      } else {
        setTimeout(() => {
          this.poll(uuid);
        }, 5000);
      }
    });
  }

  printPage() {
    window.scrollTo(0, 0);
    setTimeout(() => {
      window.print();
    }, 100);
  }

  showDebug() {
    this.showDebugging.set(!this.showDebugging());
    this.apiService.toastSuccess('Audit details ' + (this.showDebugging() ? 'visibile' : 'hidden'), '');
  }
}
